<alert></alert>
<router-outlet></router-outlet>
<sgc-modal
  *ngIf="isOpen()"
  [type]="modalEvent.type"
  [options]="modalEvent.options"
></sgc-modal>
